module.exports = __webpack_public_path__ + "static/media/spaceBackground.2e1ff225.png";